import { Outlet, Navigate } from 'react-router-dom'
import { URLS } from '../../resources/constants'
import { basicStepsHook } from '../../resources/hooks/basicStepsHook'

const OpeningBalanceExixts = () => {
    const basisStep = basicStepsHook();

    return(
        basisStep.is_beginning_balance_exists == 1 ? <Outlet/> : <Navigate to={URLS.DASHBOARD} />
    )
}

export default OpeningBalanceExixts